export const KARL_APP_TOKEN_PREFIX = 'karl_app_';

export const KARL_CLIENT_ORIGIN = 'arvid';

export const KARL_ICON_SRC = '/karl-logo.svg';

export const KARL_DEFAULT_RELAY_URL = 'https://karl-relay.onrender.com';

export const KARL_IMPLEMENT_COMMAND = 'create-feature';

export const KARL_IMPLEMENT_DOMAIN = 'app';

export const KARL_PROMPT_INTENT_MAX = 8000;

export const KARL_PROGRESS_POLL_MS = 4000;

export const KARL_RUN_STATUSES = [
  'queued',
  'dispatched',
  'running',
  'completed',
  'failed',
] as const;

export type KarlRunStatus = (typeof KARL_RUN_STATUSES)[number];

export const KARL_SEND_LABEL = 'Send to KARL';

export const KARL_SEND_FAILED = 'Could not send to KARL';

export const KARL_REFRESH_FAILED = 'Could not refresh KARL run';

export const KARL_USER_ERRORS = {
  unauthorized: 'Token missing, wrong, or revoked. Grant again in KARL.',
  invalid_prompt: 'Use a hyphenated /command-name prompt.',
  not_found: 'Unknown KARL run.',
  needs_cursor_login: 'Open KARL and click Sign in for Cursor.',
  no_workspace: 'Open a project folder in KARL.',
  waiting_for_repo: 'Open this git repo in KARL.',
  invalid_repo: 'The project GitHub repo is not a git remote KARL can match.',
  not_connected: 'KARL is not connected. Grant ARVID in KARL Settings → Agents.',
  no_summary: 'Generate a requirement summary before sending to KARL.',
  no_job: 'This requirement has not been sent to KARL yet.',
  no_github_repo: 'Link a GitHub repo to this project before sending to KARL.',
  invalid_token: 'KARL tokens start with karl_app_',
  connect_failed: 'Failed to connect. Please try again.',
} as const;
